var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirculoLineas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#24315F;}\n\t.st1{fill:#EC6923;stroke:#EC6923;stroke-width:1;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 151.2,
    cy: 152.6,
    r: 135.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 89.8,
    y1: 32.8,
    x2: 60.1,
    y2: 252.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 251.6,
    y1: 62.3,
    x2: 216.4,
    y2: 271.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 114.3,
    y1: 22.3,
    x2: 272.4,
    y2: 213.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculoLineas);
export default __webpack_public_path__ + "static/media/circulo-lineas.b62cb9d0b1323ae603aead4f7da8078e.svg";
export { ForwardRef as ReactComponent };